import { render, staticRenderFns } from "./UiCarousel.vue?vue&type=template&id=58c1051b"
import script from "./UiCarousel.vue?vue&type=script&lang=js"
export * from "./UiCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports